import { render, staticRenderFns } from "./GlobalSearchSingleOfferResult.vue?vue&type=template&id=533595d8"
import script from "./GlobalSearchSingleOfferResult.vue?vue&type=script&lang=js"
export * from "./GlobalSearchSingleOfferResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533595d8')) {
      api.createRecord('533595d8', component.options)
    } else {
      api.reload('533595d8', component.options)
    }
    module.hot.accept("./GlobalSearchSingleOfferResult.vue?vue&type=template&id=533595d8", function () {
      api.rerender('533595d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/globalSearch/GlobalSearchSingleOfferResult.vue"
export default component.exports